<template>
  <div>
    <AboutSection />
  </div>
</template>

<script setup lang="ts">
import AboutSection from '@/components/AboutSection.vue';

useHead({
  title: 'About The Players League DFW | Our Story & Mission',
  meta: [
    { name: 'description', content: 'Discover the story behind The Players League DFW, our mission to provide a competitive and enjoyable pool league experience in the Dallas-Fort Worth area, and meet our team.' },
    { property: 'og:title', content: 'About The Players League DFW | Our Story & Mission' },
    { property: 'og:description', content: 'Discover the story behind The Players League DFW, our mission to provide a competitive and enjoyable pool league experience in the Dallas-Fort Worth area, and meet our team.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://theplayersleaguedfw.com/about' },
    { property: 'og:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'About The Players League DFW | Our Story & Mission' },
    { name: 'twitter:description', content: 'Discover the story behind The Players League DFW, our mission to provide a competitive and enjoyable pool league experience in the Dallas-Fort Worth area, and meet our team.' },
    { name: 'twitter:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' }
  ]
});

/*
useSchemaOrg([
  defineAboutPage(),
  defineSportsOrganization({
    name: 'The Players League DFW',
    url: 'https://www.theplayersleague.net',
    logo: 'https://www.theplayersleague.net/TPLDFW-logo.JPEG',
    sameAs: [
      'https://www.facebook.com/groups/2431630200504644',
      'https://www.facebook.com/jimdixon76033'
    ],
    sport: 'Billiards',
    location: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Fort Worth',
        addressRegion: 'TX',
        addressCountry: 'US'
      }
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+1-817-655-5758',
        contactType: 'league inquiries',
        email: 'theplayersleaguedfw@gmail.com',
        areaServed: 'US'
      }
    ]
  })
])
*/
</script>
